/**
 * Uzysk PV w Rumunii — kWh z 1 kWp w każdym miesiącu, wg regionu rozwoju i ustawienia dachu.
 *
 * PLIK JEST GENEROWANY przez tools/pobierz_pvgis_rumunia.py (repo VV). Nie edytuj ręcznie.
 *
 * ŹRÓDŁO: PVGIS 5.3 (Komisja Europejska, JRC), baza PVGIS-SARAH3, technologia c-Si,
 * straty systemowe 14%. Punkt pomiarowy: przybliżony środek regionu.
 * Okręgi (județe) przypisane do regionów są w regionyRumunii.js.
 */

export const UZYSK_MIESIECZNY_RO = {
  "nord_vest": {
    "poludnie": [
      44.8,
      61.5,
      102.9,
      119.1,
      130.6,
      135.6,
      143.2,
      142.2,
      116.0,
      95.7,
      59.2,
      37.0
    ],
    "poludnie_bok": [
      37.5,
      54.0,
      92.9,
      112.2,
      125.9,
      133.9,
      140.5,
      135.3,
      106.8,
      84.7,
      50.3,
      30.8
    ],
    "plaski": [
      33.7,
      50.0,
      90.9,
      114.5,
      133.3,
      142.4,
      148.3,
      138.8,
      104.6,
      77.3,
      43.8,
      26.8
    ],
    "wschod_zachod": [
      25.5,
      40.0,
      76.0,
      100.7,
      119.9,
      130.0,
      134.6,
      121.7,
      88.0,
      60.8,
      32.1,
      19.6
    ],
    "jedna_polac": [
      26.1,
      40.3,
      77.8,
      102.4,
      122.3,
      130.6,
      135.4,
      122.6,
      88.6,
      60.3,
      32.0,
      19.8
    ],
    "polnoc": [
      14.2,
      19.9,
      34.7,
      64.7,
      94.7,
      109.8,
      109.0,
      80.9,
      41.4,
      21.6,
      14.4,
      10.7
    ]
  },
  "centru": {
    "poludnie": [
      46.4,
      59.1,
      98.0,
      114.6,
      130.1,
      134.2,
      144.3,
      140.2,
      113.7,
      91.3,
      60.3,
      40.6
    ],
    "poludnie_bok": [
      37.0,
      48.5,
      84.2,
      103.0,
      121.3,
      127.2,
      136.8,
      127.6,
      99.6,
      74.8,
      48.8,
      32.5
    ],
    "plaski": [
      35.9,
      49.8,
      88.2,
      110.8,
      132.7,
      140.4,
      148.9,
      137.0,
      103.7,
      76.0,
      45.9,
      30.2
    ],
    "wschod_zachod": [
      26.7,
      39.0,
      72.5,
      95.6,
      117.5,
      125.4,
      131.9,
      117.5,
      85.6,
      58.4,
      32.8,
      21.6
    ],
    "jedna_polac": [
      29.4,
      43.3,
      78.3,
      101.5,
      123.3,
      130.7,
      136.3,
      123.1,
      90.6,
      64.2,
      35.3,
      23.2
    ],
    "polnoc": [
      15.0,
      20.6,
      36.2,
      64.5,
      94.0,
      106.1,
      107.3,
      80.5,
      43.3,
      22.6,
      14.8,
      11.8
    ]
  },
  "nord_est": {
    "poludnie": [
      47.3,
      61.0,
      103.1,
      119.8,
      136.0,
      134.7,
      145.3,
      143.0,
      119.5,
      94.4,
      56.5,
      44.0
    ],
    "poludnie_bok": [
      39.9,
      53.5,
      95.1,
      114.3,
      132.7,
      132.7,
      141.9,
      137.1,
      110.7,
      83.5,
      48.3,
      36.6
    ],
    "plaski": [
      34.8,
      49.6,
      90.7,
      115.0,
      138.8,
      141.4,
      150.3,
      139.6,
      107.4,
      76.1,
      41.9,
      30.8
    ],
    "wschod_zachod": [
      25.9,
      40.0,
      75.8,
      100.8,
      124.8,
      129.3,
      135.9,
      122.5,
      90.5,
      60.2,
      31.1,
      21.8
    ],
    "jedna_polac": [
      26.2,
      40.7,
      75.1,
      100.7,
      125.4,
      130.5,
      137.4,
      122.5,
      90.2,
      60.1,
      30.8,
      22.0
    ],
    "polnoc": [
      13.5,
      20.8,
      33.9,
      64.4,
      97.8,
      108.9,
      109.6,
      81.3,
      41.3,
      21.7,
      14.1,
      10.8
    ]
  },
  "sud_est": {
    "poludnie": [
      52.7,
      70.0,
      112.8,
      128.8,
      143.3,
      143.1,
      155.0,
      154.3,
      130.4,
      103.6,
      62.0,
      48.9
    ],
    "poludnie_bok": [
      45.0,
      62.2,
      104.1,
      124.0,
      140.9,
      140.9,
      152.4,
      148.6,
      120.1,
      92.2,
      54.0,
      41.3
    ],
    "plaski": [
      39.3,
      57.1,
      99.5,
      124.4,
      147.3,
      151.4,
      161.8,
      151.7,
      117.9,
      84.6,
      47.0,
      35.2
    ],
    "wschod_zachod": [
      30.0,
      45.7,
      82.9,
      109.2,
      132.7,
      138.3,
      146.5,
      133.4,
      99.5,
      67.3,
      35.5,
      25.4
    ],
    "jedna_polac": [
      30.3,
      45.6,
      82.0,
      108.3,
      132.4,
      139.9,
      147.5,
      133.4,
      100.3,
      67.2,
      34.7,
      25.5
    ],
    "polnoc": [
      15.2,
      21.1,
      36.2,
      70.4,
      105.1,
      117.6,
      119.0,
      89.6,
      46.7,
      23.2,
      15.9,
      12.4
    ]
  },
  "sud_muntenia": {
    "poludnie": [
      55.5,
      73.8,
      113.6,
      128.5,
      138.0,
      139.5,
      153.0,
      149.6,
      125.5,
      101.1,
      62.2,
      52.0
    ],
    "poludnie_bok": [
      48.2,
      66.4,
      104.8,
      122.8,
      135.9,
      138.7,
      151.0,
      144.6,
      116.6,
      90.6,
      54.9,
      44.5
    ],
    "plaski": [
      41.8,
      60.1,
      100.8,
      124.4,
      142.4,
      147.9,
      159.9,
      147.7,
      114.3,
      83.1,
      47.4,
      37.3
    ],
    "wschod_zachod": [
      31.9,
      48.2,
      84.7,
      109.4,
      128.9,
      135.4,
      145.2,
      130.3,
      97.1,
      66.5,
      36.1,
      27.3
    ],
    "jedna_polac": [
      31.6,
      47.4,
      84.4,
      109.6,
      128.8,
      135.5,
      145.5,
      129.7,
      97.2,
      66.1,
      35.0,
      26.9
    ],
    "polnoc": [
      16.0,
      21.7,
      37.9,
      71.6,
      103.8,
      116.4,
      119.4,
      89.7,
      47.5,
      23.3,
      16.1,
      13.0
    ]
  },
  "bucuresti_ilfov": {
    "poludnie": [
      59.6,
      77.4,
      114.6,
      127.7,
      137.3,
      136.6,
      150.5,
      149.4,
      125.7,
      101.3,
      64.4,
      55.4
    ],
    "poludnie_bok": [
      51.9,
      69.0,
      105.8,
      122.2,
      134.7,
      134.9,
      147.7,
      144.1,
      117.0,
      91.0,
      56.7,
      47.6
    ],
    "plaski": [
      44.6,
      62.7,
      101.7,
      123.7,
      141.6,
      144.9,
      157.5,
      147.6,
      114.5,
      83.3,
      48.9,
      39.5
    ],
    "wschod_zachod": [
      33.9,
      50.0,
      85.0,
      108.8,
      128.1,
      132.9,
      142.9,
      130.2,
      97.1,
      66.5,
      37.0,
      28.5
    ],
    "jedna_polac": [
      33.4,
      49.5,
      84.4,
      108.8,
      128.5,
      134.3,
      144.4,
      130.1,
      96.9,
      65.6,
      35.7,
      27.8
    ],
    "polnoc": [
      16.7,
      21.9,
      38.0,
      71.3,
      103.2,
      114.8,
      117.9,
      89.6,
      47.4,
      23.2,
      16.1,
      13.1
    ]
  },
  "sud_vest_oltenia": {
    "poludnie": [
      63.9,
      74.1,
      113.6,
      127.5,
      139.0,
      143.1,
      154.8,
      147.6,
      123.2,
      101.2,
      61.1,
      56.3
    ],
    "poludnie_bok": [
      54.6,
      65.9,
      104.7,
      122.1,
      136.7,
      142.6,
      153.1,
      143.4,
      114.0,
      90.4,
      53.4,
      47.9
    ],
    "plaski": [
      46.9,
      59.9,
      100.7,
      123.3,
      143.2,
      151.7,
      161.8,
      145.8,
      112.3,
      83.0,
      46.4,
      39.9
    ],
    "wschod_zachod": [
      34.5,
      48.0,
      84.7,
      108.6,
      129.4,
      139.0,
      147.1,
      129.2,
      95.6,
      66.5,
      35.4,
      28.9
    ],
    "jedna_polac": [
      34.3,
      47.8,
      84.6,
      108.2,
      129.2,
      138.9,
      147.0,
      127.5,
      96.3,
      66.1,
      34.8,
      28.5
    ],
    "polnoc": [
      15.4,
      21.1,
      37.1,
      71.0,
      103.9,
      119.2,
      120.8,
      89.0,
      47.1,
      23.0,
      15.7,
      13.1
    ]
  },
  "vest": {
    "poludnie": [
      51.6,
      66.9,
      107.8,
      124.0,
      133.3,
      138.8,
      148.2,
      143.1,
      115.1,
      101.3,
      66.2,
      45.3
    ],
    "poludnie_bok": [
      43.8,
      59.4,
      99.1,
      118.0,
      129.6,
      137.0,
      145.9,
      138.0,
      107.2,
      89.8,
      57.0,
      38.6
    ],
    "plaski": [
      38.3,
      54.2,
      95.4,
      119.5,
      136.7,
      146.4,
      154.3,
      140.7,
      104.8,
      82.3,
      49.0,
      32.4
    ],
    "wschod_zachod": [
      28.8,
      43.5,
      80.3,
      104.9,
      123.8,
      133.7,
      140.4,
      124.6,
      89.2,
      65.7,
      36.5,
      23.7
    ],
    "jedna_polac": [
      29.0,
      43.5,
      80.6,
      105.1,
      125.3,
      134.6,
      141.2,
      124.2,
      89.2,
      65.6,
      36.2,
      23.4
    ],
    "polnoc": [
      14.3,
      19.8,
      35.6,
      67.7,
      98.7,
      114.2,
      114.9,
      84.6,
      43.6,
      22.2,
      15.2,
      11.7
    ]
  }
}
